import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppTextResourcesService {
  public readonly WARNING_CUI_TITLE = 'Warning: CUI // SP-CTI';
  public readonly WARNING_CUI_MESSAGE = 'This document may contain Controlled Unclassified Information. Handle in accordance with <a href=\'https://www.archives.gov\' target=\'_blank\' onclick=\'event.stopPropagation()\'>NARA CUI guidance</a>';
  
  public readonly WARNING_PERSONAL_INFO_TITLE = "Attention";
  public readonly WARNING_PERSONAL_MESSAGE = "By providing your email address, you agree to receive system-generated notifications, security alerts, and administrative updates from Rizkly.<BR />We respect your privacy and will not share your information with third parties.<BR />You may contact Rizkly to discuss your communication preference further.";

  public readonly LBL_I_UNDERSTAND = 'I understand';
}
